<template>
  <div>
    <UPageHero :ui="{ container: 'gap-5 sm:gap-y-5' }">
      <template #top>
        <HeroBackground />
      </template>

      <template #title>
        <div>
          <NuxtImg
            src="/images/cirrus_logo_blue.png"
            sizes="sm:50vw md:400px"
            class="m-auto"
            alt="Cirrus Logo"
          />
          <h2 class="text-primary mt-5 text-2xl">
            Your ebooks on Your website on Your terms
          </h2>
        </div>
      </template>
      <SignUpForm />
    </UPageHero>
  </div>
</template>
<script lang="ts" setup>
definePageMeta({
  layout: "home",
  colorMode: "light",
});
</script>
